var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{staticClass:"border-none rounded-lg",attrs:{"body-style":{
    padding: '1rem',
    boxShadow: '0 0 30px -12px rgb(0 0 0 / 0.25)',
    borderRadius: '0.5rem',
  }}},[_c('p',{staticClass:"text-center font-bold mb-2",staticStyle:{"font-size":"4rem"}},[_c('a-icon',{attrs:{"type":_vm.icon}}),_vm._v(" "+_vm._s(_vm.value)+" ")],1),_c('p',{staticClass:"mb-0 text-center font-medium"},[_vm._v(" "+_vm._s(_vm.$t(("users_report_statistics_field_key_" + _vm.fieldKey)))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }